import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.14 20.6a7.002 7.002 0 0 1 13.72 0A10.954 10.954 0 0 1 12 23c-2.594 0-4.979-.898-6.86-2.4zm-.847-.752A10.967 10.967 0 0 1 1 12C1 5.925 5.925 1 12 1s11 4.925 11 11c0 3.073-1.26 5.852-3.293 7.848a8.017 8.017 0 0 0-5.283-5.474 5 5 0 1 0-4.849 0 8.017 8.017 0 0 0-5.282 5.474zM12 14a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"
});

var SvgAccountFilled = function SvgAccountFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgAccountFilled;